import classNames from 'classnames'
import Button, { ButtonProps } from '@insided/control/uikit/Button'
import { FunctionalComponent } from 'preact'

const deriveOnClick = (onClick?: JSX.MouseEventHandler | string) => {
  if (typeof onClick === 'function') {
    return onClick
  }
  if (typeof onClick === 'string' && onClick !== '') {
    const onClickSelector = onClick
    return () => window?.document?.getElementById(onClickSelector)?.click()
  }
  return undefined
}

interface ButtonControlProps extends Omit<ButtonProps, 'onClick' | 'variant'> {
  onClick?: JSX.MouseEventHandler | string
  class?: string
  newStyle?: boolean
  variant?: string
  /**
   * deprecated, use `className` instead
   */
  customClassName?: string
}

/**
 * @deprecated
 * ```
 * import Button from '@insided/control/uikit/Button'
 * ```
 */
const ButtonControl: FunctionalComponent<ButtonControlProps> = (props) => {
  const {
    class: customClass,
    className,
    disabled,
    fullWidth,
    icon,
    onClick,
    title,
    variant = 'secondary',
    isLoading,
    newStyle,
    outlined,
    type,
    size,
    customClassName
  } = props
  if (!icon && !title) {
    return null
  }

  const derivedOnClick = deriveOnClick(onClick)
  const sharedClassNames = classNames(className, customClass, customClassName)
  return (
    <Button
      className={
        newStyle
          ? sharedClassNames
          : classNames('button-control', sharedClassNames, {
              [`button-control--${variant}`]: !outlined,
              [`button-control--${variant}--outlined`]: outlined,
              'button-control--full-width': fullWidth,
              'button-control--icon': icon
            })
      }
      oldStyle={!newStyle}
      isLoading={isLoading}
      onClick={derivedOnClick}
      // @ts-expect-error
      variant={variant}
      type={type}
      icon={icon}
      title={title}
      size={size}
      disabled={disabled}
    />
  )
}

export default ButtonControl
